var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('InputEditor',{attrs:{"error-messages":_vm.contentErrors,"label":_vm.$t('description'),"required":true},model:{value:(_vm.item.content),callback:function ($$v) {_vm.$set(_vm.item, "content", $$v)},expression:"item.content"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }